import { COLORS, RANGES, UNITS, WORKTOPS } from './cloudinaryImages'
import { RANGE_PRICES, WORKTOP_PRICES } from './prices'

const sections = [
  {
    id: 'range',
    type: 'range',
    title: 'Kjøkkenmodeller',
    shortTitle: 'Kjøkken',
    description: 'Velg din kjøkkensmodell.',
    tooltip: {
      title: 'Våre kjøkkenmodeller',
      description: [
        'Vi tilbyr et bredt sortiment kjøkkenmodeller i ulike stiler. Prisen kan variere for like modeller avhengig av farge og materialvalg. ',
        'Kontakt din lokale forhandler for mer informasjon om pris og utvalg.',
      ],
    },
    cards: [
      {
        title: 'Signatur Favn',
        collection: 'Sigdal',
        description:
          'Signatur Favn er mer enn et kjøkken. Det er en idé og et formspråk inspirert av vår nordiske natur. Vår visjon er at kjøkkenet skal gi deg samme ro og harmoni som et besøk i naturen selv. Inspirasjonen har vi hentet fra våre vakre eikeskoger.',
        colors: COLORS.signatureFavn,
        prices: {
          small: RANGE_PRICES.signatureFavn[0],
          medium: RANGE_PRICES.signatureFavn[1],
          large: RANGE_PRICES.signatureFavn[2],
        },
        image: RANGES.signatureFavn,
      },
      {
        title: 'Amfi Eik',
        collection: 'Sigdal',
        description:
          'Elegant og moderne eikekjøkken. Slette fronter i eikefinér med integrert kantlist i eik som markerer kjøkkenets linjer og komposisjon. Finnes i alle Jordnærfarger, 4 beisfarger og natur.',
        colors: COLORS.amfiEik,
        prices: {
          small: RANGE_PRICES.amfiEik[0],
          medium: RANGE_PRICES.amfiEik[1],
          large: RANGE_PRICES.amfiEik[2],
        },
        image: RANGES.amfiEik,
      },
      {
        title: 'Forte',
        collection: 'Sigdal',
        description:
          'Robust og lettstelt kjøkkenmodell i hvitt høytrykkslaminat. Med sin enkle og rene formgivning er modellen velegnet for voluminnredninger med mye oppbevaringsplass.',
        colors: COLORS.forte,
        prices: {
          small: RANGE_PRICES.forte[0],
          medium: RANGE_PRICES.forte[1],
          large: RANGE_PRICES.forte[2],
        },
        image: RANGES.forte,
      },
      {
        title: 'Herregaard',
        collection: 'Sigdal',
        description:
          'Eksklusivt tradisjonskjøkken med herskapelig preg. Klassiske speilfronter med fylling og markerte profilspor som gir dybdevirkning og skyggespill. Klassisk årgangskjøkken med sjel, som lever opp til navnet. Finnes i alle Jordnærfarger.',
        colors: COLORS.herregaard,
        prices: {
          small: RANGE_PRICES.herregard[0],
          medium: RANGE_PRICES.herregard[1],
          large: RANGE_PRICES.herregard[2],
        },
        image: RANGES.herregaard,
      },
      {
        title: 'Herregaard eik',
        collection: 'Sigdal',
        description:
          'Eksklusivt eikekjøkken i kontinental design. Klassiske speilfronter med ramtre og profilert fylling som gir dybdevirkning og skyggespill. Få med deg de store tilvalgsmulighetene for personlig utforming. Finnes i alle Jordnærfarger, 3 beisfarger og natur.',
        colors: COLORS.herregardEik,
        prices: {
          small: RANGE_PRICES.herregardEik[0],
          medium: RANGE_PRICES.herregardEik[1],
          large: RANGE_PRICES.herregardEik[2],
        },
        image: RANGES.herregardEik,
      },
      {
        title: 'Horisont',
        collection: 'Sigdal',
        description:
          'Herlig trendkjøkken med slette fronter og innfreste grep, som markerer modellens linjerene design. Horisont kjennetegnes av en klar og kjølig friskhet, noe som representerer ny nordisk design på sitt beste. Finnes i alle Jordnærfarger.',
        colors: COLORS.horizont,
        prices: {
          small: RANGE_PRICES.horisont[0],
          medium: RANGE_PRICES.horisont[1],
          large: RANGE_PRICES.horisont[2],
        },
        image: RANGES.horizont,
      },
      {
        title: 'Line',
        collection: 'Sigdal',
        description:
          'Line er en modell med et stort designregister. Med sine slette MDF-fronter i hele 15 forskjellige malte farger – pluss mulighet for fargetilpasset forkant på skrogene – gir Line deg absolutt alle muligheter. Finnes i alle Jordnærfarger.',
        colors: COLORS.line,
        prices: {
          small: RANGE_PRICES.line[0],
          medium: RANGE_PRICES.line[1],
          large: RANGE_PRICES.line[2],
        },
        image: RANGES.line,
      },
      {
        title: 'Sand',
        collection: 'Sigdal',
        description:
          'Nett og møbleringsvennlig modell med slette, renholdsvennlige fronter. Stilen er lavmælt, nøktern og uprangende og derfor velegnet til enkle, stilistiske interiørløsninger.',
        colors: COLORS.sand,
        prices: {
          small: RANGE_PRICES.sand[0],
          medium: RANGE_PRICES.sand[1],
          large: RANGE_PRICES.sand[2],
        },
        image: RANGES.sand,
      },
      {
        title: 'Scala',
        collection: 'Sigdal',
        description:
          'Nett og tidløs crossover-modell. Fronter med enkel ramme og slett fylling, noe som kombinerer vintage kjøkkendesign med et moderne uttrykk. Du kan forsterke det ene eller det andre gjennom valg av tilbehør. Finnes i alle Jordnærfarger.',
        colors: COLORS.scala,
        prices: {
          small: RANGE_PRICES.scala[0],
          medium: RANGE_PRICES.scala[1],
          large: RANGE_PRICES.scala[2],
        },
        image: RANGES.scala,
      },
      {
        title: 'Solido',
        collection: 'Sigdal',
        description:
          'Ønsker du en interiørstil som utstråler diskret eleganse, kan du med hell velge Solido. Modellen har slette fronter i sort supermatt høytrykkslaminat med fasede kantlister i heltre eik. ',
        colors: COLORS.solido,
        prices: {
          small: RANGE_PRICES.solidoHvit[0],
          medium: RANGE_PRICES.solidoHvit[1],
          large: RANGE_PRICES.solidoHvit[2],
        },
        image: RANGES.solido,
      },
      {
        title: 'Square eik',
        collection: 'Sigdal',
        description:
          'Rustikk og landlig kjøkkenmodell i heltre eik. Front med enkel ramme og slett fylling gjør at du kan variere uttrykket på kjøkkenet fra det helt moderne til det rustikke landlige preget alt etter hvilket tilbehør du velger. Finnes i alle Jordnærfarger, 4 beisfarger og natur.',
        colors: COLORS.squareEik,
        prices: {
          small: RANGE_PRICES.squareEik[0],
          medium: RANGE_PRICES.squareEik[1],
          large: RANGE_PRICES.squareEik[2],
        },
        image: RANGES.squareEik,
      },
      {
        title: 'Uno',
        collection: 'Sigdal',
        description:
          'Uno er en ”kameleon-modell” som tilpasser seg omgivelsene og blir akkurat det kjøkkenet du gjør den til. Med 15 farger å velge blant og lette, renholdsvennlige flater et dette en ultra-praktisk kjøkkenmodell! Finnes i alle Jordnærfarger.',
        colors: COLORS.uno,
        prices: {
          small: RANGE_PRICES.uno[0],
          medium: RANGE_PRICES.uno[1],
          large: RANGE_PRICES.uno[2],
        },
        image: RANGES.uno,
      },
      {
        title: 'Vidde Snø',
        collection: 'Sigdal',
        description:
          'Slette fronter i hvit eller grå melamin er et godt utgangspunkt for et lyst og innbydende trivselskjøkken. Modellens presise og kubistiske formspråk gjør den velegnet for utstrakt bruk av takhøye skapløsninger med god plassutnyttelse.',
        colors: COLORS.vidde,
        prices: {
          small: RANGE_PRICES.vidde[0],
          medium: RANGE_PRICES.vidde[1],
          large: RANGE_PRICES.vidde[2],
        },
        image: RANGES.vidde,
      },
      {
        title: 'Fjell',
        collection: 'Sigdal',
        description:
          'Kjøkkemodellen Fjell er et realt brukskjøkken med praktiske egenskaper. Dette er en prisgunstig modell med slette melamin-fronter i en vakker grå farge.',
        colors: COLORS.fjell,
        prices: {
          small: RANGE_PRICES.fjell[0],
          medium: RANGE_PRICES.fjell[1],
          large: RANGE_PRICES.fjell[2],
        },
        image: RANGES.fjell,
      },
      {
        title: 'Eikeli',
        collection: 'Sigdal',
        description:
          'Eikeli representerer en lun og nordisk eiketrend. Med sine malte lamellfronter i heltre eik, byr modellen på referanser til både kulinarisk bistro og urbane kafémiljøer. Eikeli fåes kun som underskap, men kan enkelt kombineres med åpne Bistrohyller og høyskap med slette eikefronter.',
        colors: COLORS.eikeli,
        prices: {
          small: RANGE_PRICES.eikeli[0],
          medium: RANGE_PRICES.eikeli[1],
          large: RANGE_PRICES.eikeli[2],
        },
        image: RANGES.eikeli,
      },
    ],
  },
  {
    id: 'units',
    title: 'Kjøkkenstørrelse',
    shortTitle: 'Kjøkkenstørrelse',
    type: 'units',
    description: 'Velg størrelse på ditt kjøkken.',
    tooltip: {
      title: 'Kjøkkenstørrelse',
      description: [
        'Lite kjøkken < 10 m2 rommer 5 underskap, 3 veggskap, 1 høyskap.',
        'Vinkelkjøkken 10-20 m2 rommer 8 underskap, 5 veggskap, 2 høyskap.',
        'Kjøkken med kjøkkenøy < 20 m2 rommer 12 underskap, 8 veggskap, 3 høyskap samt kjøkkenøy.',
      ],
    },
    cards: [
      {
        type: 'small',
        title: 'Lite kjøkken',
        price: 0,
        image: UNITS.small,
      },
      {
        type: 'medium',
        title: 'Vinkelkjøkken',
        price: 0,
        image: UNITS.medium,
      },
      {
        type: 'large',
        title: 'Kjøkken med kjøkkenøy',
        price: 0,
        image: UNITS.large,
      },
    ],
  },
  {
    id: 'worktops',
    title: 'Benkeplater',
    type: 'simple',
    description: 'Velg hvilken type benkeplate du vil ha.',
    tooltip: {
      title: 'Våre benkeplater',
      description: [
        'Vi har et bredt utvalg benkeplater i ulike utforminger og materialer, her ser du kun et lite utvalg. Ved å velge mellom lamiant, massivt tre og granitt kombinert med kjøkkenstørrelsen får du en cirkapris på ditt kjøkken.',
        'For eksakt pris på ditt nye kjøkken, avtal møte med en kjøkkendesigner.',
      ],
    },
    cards: [
      {
        title: 'Laminat',
        description:
          'Benkeplater i laminat finnes i et bredt sortiment med en mengde ulike overflater, mønster og farger.',
        prices: {
          small: WORKTOP_PRICES.laminate[0],
          medium: WORKTOP_PRICES.laminate[1],
          large: WORKTOP_PRICES.laminate[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Massivt tre',
        description:
          'Benkeplater i massivt tre er både levende og varmt, genuint og vakkert som varer over tid.',
        prices: {
          small: WORKTOP_PRICES.solidTimber[0],
          medium: WORKTOP_PRICES.solidTimber[1],
          large: WORKTOP_PRICES.solidTimber[2],
        },
        image: WORKTOPS.wood,
      },
      // {
      //   title: 'Rostfri',
      //   description:
      //     'En rostfri bänkskiva är ett snyggt, lättskött och tåligt alternativ till ditt kök.',
      //   prices: {
      //     small: WORKTOP_PRICES.stainless[0],
      //     medium: WORKTOP_PRICES.stainless[1],
      //     large: WORKTOP_PRICES.stainless[2],
      //   },
      //   image: WORKTOPS.stainless,
      // },
      {
        title: 'Granitt',
        description:
          'De vakre benkeplatene i granitt finnes i en mangde ulike luksuriøse utforminger som passer alle typer kjøkken. Hver plate er unik så du kan være sikker på å få et spesielt kjøkken.',
        prices: {
          small: WORKTOP_PRICES.granite[0],
          medium: WORKTOP_PRICES.granite[1],
          large: WORKTOP_PRICES.granite[2],
        },
        defmessage: 'Kontakt forhandler for pris på granitt.',
        image: WORKTOPS.granite,
      },
    ],
  },
  {
    id: 'estimate',
    title: 'Estimat',
    type: 'summary',
    description: '',
    tooltip: {},
  },
]

export default sections
